<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {

   computed: {

    load() {

      return this.$store.getters.loading;
    },
  }
}
</script>

<style lang="scss">
  @import './assets/scss/index.scss';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


</style>
